import { render, staticRenderFns } from "./widget-list.vue?vue&type=template&id=cd220e0c&scoped=true"
import script from "./widget-list.vue?vue&type=script&lang=ts"
export * from "./widget-list.vue?vue&type=script&lang=ts"
import style0 from "./widget-list.vue?vue&type=style&index=0&id=cd220e0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd220e0c",
  null
  
)

export default component.exports